import ClusterMarker from './ClusterMarker'
export default ClusterMarker
